import type { ButtonHTMLAttributes } from 'react';
import { PS, T } from '../lib/theme';

type Variant = 'primary' | 'secondary' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const STYLES: Record<Variant, { bg: string; fg: string; border: string }> = {
  primary:   { bg: PS.red,    fg: PS.white,    border: PS.red },
  secondary: { bg: PS.white,  fg: PS.nearBlack, border: PS.border },
  danger:    { bg: PS.danger, fg: PS.white,    border: PS.danger },
};

export function Button({ variant = 'primary', style, disabled, ...rest }: Props) {
  const s = STYLES[variant];
  return (
    <button
      {...rest}
      disabled={disabled}
      style={{
        background: disabled ? PS.surfaceDisabled : s.bg,
        color: disabled ? PS.textTer : s.fg,
        border: `1px solid ${disabled ? PS.border : s.border}`,
        padding: '8px 16px',
        borderRadius: 3,
        cursor: disabled ? 'not-allowed' : 'pointer',
        textTransform: 'uppercase',
        ...T.buttonLabel,
        ...style,
      }}
    />
  );
}
